import { render, staticRenderFns } from "./Categorizacion.vue?vue&type=template&id=610e6c2c&scoped=true"
import script from "./Categorizacion.vue?vue&type=script&lang=js"
export * from "./Categorizacion.vue?vue&type=script&lang=js"
import style0 from "./Categorizacion.vue?vue&type=style&index=0&id=610e6c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610e6c2c",
  null
  
)

export default component.exports